import React, { useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  TextField, IconButton, Radio, Button, Paper, Typography,Box
} from '@mui/material';
import { Add, Delete } from '@mui/icons-material';
import { useRecordContext } from 'react-admin';


  const OperationPlanField = () => {
    const record = useRecordContext(); // Get the current form record
    const selectedPlanId = record?.selected_plan_id || null; // Get selected plan ID from form values
    const operationPlans = record?.operation_plan || []; // Get the operation plan list
    const [plans, setPlans] = useState(operationPlans);


  const columnConfig = [
    // Round-related fields
    { field: 'id', label: 'ID', ttype: 'readonly' },
    { field: 'sub_day', label: 'اليوم', ttype: 'readonly' },

    { field: 'rounds', label: 'الرد', ttype: 'readonly' },
    { field: 'allocated_seats', label: 'المسكنين', type: 'readonly' },
    { field: 'reversed_seats', label: 'المشمولين', type: 'readonly' },

    // School-related fields
    { field: 'scname', label: 'أسم المدرسة', ttype: 'readonly' },
    { field: 'ministerial_number', label: 'الرقم الوزاري', ttype: 'readonly' },
    { field: 'school_type', label: 'نوع المدرسة', ttype: 'readonly' },
    { field: 'sector', label: 'المنطقة', ttype: 'readonly' },
    { field: 'administration', label: 'أدارة التعليم', ttype: 'readonly' },
    { field: 'office', label: 'مكتب التعليم', ttype: 'readonly' },
    { field: 'gender', label: 'جنس الطلاب', ttype: 'readonly' },
    { field: 'education_level', label: 'المرحلة', ttype: 'readonly' },

    // Bus-related fields
    { field: 'contract_number', label: 'رقم العقد', ttype: 'readonly' },
    { field: 'opname', label: 'المتعهد', ttype: 'readonly' },
    { field: 'operationnumber', label: 'الرقم التشغيلي', ttype: 'readonly' },
    { field: 'operatortype', label: 'نوع المتعهد', ttype: 'readonly' },
    { field: 'sub_operator', label: 'متعهد الباطن', ttype: 'readonly' },
    { field: 'yearmodel', label: 'سنة الصنع', ttype: 'readonly' },
    { field: 'brand', label: 'الموديل', ttype: 'readonly' },
    { field: 'plateletters', label: 'حروف اللوحة', ttype: 'readonly' },
    { field: 'platenumbers', label: 'أرقام اللوحة', ttype: 'readonly' },
    { field: 'capacity', label: 'سعة الركاب', ttype: 'readonly' },
    { field: 'serial_number', label: 'الرقم التسلسلى للحافلة', ttype: 'readonly' },
    { field: 'deviceimei', label: 'رقم جهاز التتبع', ttype: 'readonly' },
    { field: 'operation_card_expiration_date', label: 'تاريخ انتهاء بطاقة التشغيل', ttype: 'readonly' },

    // Driver-related fields
    { field: 'name', label: 'أسم السائق', ttype: 'readonly' },
    { field: 'nid_number', label: 'رقم الهوية', ttype: 'readonly' },
    { field: 'nationalitie', label: 'الجنسية', ttype: 'readonly' },
    { field: 'mobileno', label: 'رقم الجوال', ttype: 'readonly' },
    { field: 'driver_license_type', label: 'نوع الرخصة', ttype: 'readonly' },
    { field: 'license_expiration_date', label: 'تاريخ انتهاء الرخصة', ttype: 'readonly' },
    { field: 'driving_card_end_date', label: 'تاريخ انتهاء بطاقة القيادة', ttype: 'readonly' },
    { field: 'last_gps_signal', label: 'تاريخ أخر اشارة تتبع', ttype: 'readonly' },



    // Commented-out fields (Optional for future use)
    // { field: 'contract_id', label: 'معرف العقد', ttype: 'readonly' },
    // { field: 'operator_id', label: 'المعرف المتعهد', ttype: 'readonly' },
    // { field: 'school_count_move', label: 'المدارس المتحركة', type: 'readonly' },
    // { field: 'assigned_students_move', label: 'الطلاب المسندين (متحرك)', type: 'readonly' },
    // { field: 'school_count_nomove', label: 'المدارس الثابتة', type: 'readonly' },
    // { field: 'assigned_students_nomove', label: 'الطلاب المسندين (ثابت)', type: 'readonly' },
  ];



  useEffect(() => {

    setPlans(operationPlans); // Sync with form state whenever operation_plan changes
  }, [operationPlans]);






  return (
    <>
      {plans && plans.length > 0 ? (
        <Box sx={{ width: '95vw', maxWidth:'95vw', overflow: 'auto', maxHeight: '400px' }}>
          <TableContainer
            component={Paper}
            sx={{
              width: 'max-content', // Forces table to expand horizontally within the scrollable container
              minWidth: 1500,
            }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ height: '50px', whiteSpace: 'nowrap' }}></TableCell>
                  {columnConfig.map((col) => (
                    <TableCell
                      key={col.field}
                      sx={{
                        height: '50px',
                        textAlign: 'center',
                        whiteSpace: 'nowrap',
                        minWidth: '150px',
                      }}
                    >
                      {col.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {plans.map((plan) => (
                  <TableRow key={plan.id}>
                    <TableCell>
                      <Radio checked={selectedPlanId === plan.id} disabled />
                    </TableCell>
                    {columnConfig.map((col) => (
                      <TableCell
                        key={col.field}
                        sx={{
                          height: '50px',
                          textAlign: 'center',
                          whiteSpace: 'nowrap',
                          minWidth: '150px',
                        }}
                      >
                        {plan[col.field]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : (
        <div style={{ textAlign: 'center', padding: '20px', fontSize: '16px', color: 'gray' }}>
          لا يوجد خطة تشغيلية للحافلة فى النظام بعد
        </div>
      )}
    </>
  );
  
};

export default OperationPlanField;
